import { useQuery } from '@apollo/client'
import { isEmptyOrNull } from '@tecsinapse/es-utils/build'
import gql from 'graphql-tag'
import React from 'react'
import { Loading } from './loading'

export const arquivoQueryGql = gql`
  query ArquivoQuery($idArquivo: ID!) {
    arquivo(idArquivo: $idArquivo) {
      id
      nome
      tamanho
    }
  }
`

export const linkDownloadByArquivoQueryGql = gql`
  query LinkDownloadByArquivoQuery($idArquivo: ID!) {
    linkDownloadByArquivo(idArquivo: $idArquivo)
  }
`

export const downloadByLink = url => {
  const link = document.createElement('a')

  link.href = url
  link.target = '_blank'
  link.click()
}

export const downloadByButton = url => {
  const button = document.createElement('button')

  button.addEventListener('click', () => {
    window.open(url, '_blank')
  })

  button.click()
}

export const UploadedFile = ({ idArquivo, children }) => {
  const { data: { arquivo } = {}, loading } = useQuery(arquivoQueryGql, {
    fetchPolicy: 'cache-first',
    variables: { idArquivo },
    skip: isEmptyOrNull(idArquivo)
  })

  if (loading) {
    return <Loading />
  }

  return children ? children({ arquivo: arquivo || null }) : null
}
